/* eslint no-console:0 */
require("idempotent-babel-polyfill");

if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }
L2H.$ = $;
L2H.Handlebars = Handlebars;

require('vendor/jquery.touchSwipe.min.js');
require('vendor/jquery.ba-throttle-debounce.js');
require('vendor/jquery.throttledresize.js');
require('google-analytics.js');
require('detect.js');
require('console-polyfill.js');
require('photo-modal-body-view.js');
require('photo-modal-view.js');
require('shopables-view.js');
require('tracker.js');
require('internal-tracker.js');
require('widget.js');
require('scrollable-widget.js');
require('looff-widget.js');
require('grid-widget.js');
require('stacking-grid-widget.js');
require('personalized-grid-widget.js');
require('gallery-widget.js');
require('patchwork-widget.js');
require('personalized-widget.js');
require('broken-photo-check.js');

if (L2H.debug) {
  console.log("L2H DEBUG: Using webpack version");
}
